// `summary` and `highlights` are optional. Add only things that are true and
// that you can discuss in an interview; empty fields simply aren't rendered.
// An entry without startYear/endYear renders without a date line.
export const experienceData = [
    {
        id: 0,
        company: 'Ethiopian Artificial Intelligence Institute',
        jobtitle: 'Senior Software Engineer',
        startYear: '2024',
        endYear: 'Present',
        summary: 'Mostly full-stack development, alongside computer vision and machine learning work.',
        highlights: [
            'Build full-stack applications with Django, React.js, Next.js and Node.js/Express.js on PostgreSQL, MySQL and MongoDB, with Swagger, Postman and Tailwind CSS in the toolchain, including authentication and access control.',
            'Containerize and orchestrate services with Docker and Kubernetes in a microservices architecture.',
            'Implement real-time notifications and service messaging with Redis pub/sub.',
            'Research, design, train and evaluate computer vision, machine learning and deep learning models.',
        ],
    },
    {
        id: 1,
        company: 'AfterQuery',
        jobtitle: 'Coding Evaluation Task Author',
        startYear: 'Jun 2026',
        endYear: 'Present',
        summary: 'Authored tasks for coding evaluations.',
        highlights: [],
    },
    {
        id: 2,
        company: 'DrongoERP',
        jobtitle: 'Backend Developer',
        startYear: 'Aug 2024',
        endYear: 'Nov 2024',
        summary: '',
        highlights: [
            'Built a Node.js service that ingests, processes and stores ZKTeco biometric device data in the ERP backend.',
            'Packaged it as an unattended Windows service (NSSM) for continuous operation.',
            'Implemented thermal-printer support over the Web Bluetooth API and serial port.',
        ],
    },
    {
        id: 3,
        company: 'Debo Engineering PLC',
        jobtitle: 'Junior Software Engineer',
        startYear: '2023',
        endYear: '2024',
        summary: '',
        highlights: [
            'Developed and maintained backend and frontend applications in Java, JavaScript and Python across Django, Laravel and MERN stacks.',
            'Built an LLM-powered RAG chatbot (OpenAI API + LangChain) over legal and case documents for the Civil Case Management System.',
            'Took part in code reviews, debugging, testing and agile workflows.',
        ],
    },
]
